// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* P11-BATCH-004 — scoped Session Log tab. Do not import prototype chrome. */

.ms-sl {
    color: #1f2937;
}

.ms-sl-header {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
}

.ms-sl-title {
    margin: 0 0 4px;
    font-size: 22px;
    font-weight: 700;
    color: #111827;
}

.ms-sl-sub {
    margin: 0;
    font-size: 13px;
    color: #6b7280;
}

.ms-sl-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 36px;
    padding: 6px 16px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 600;
}

.ms-sl-btn--green {
    border: 1px solid #5cae48;
    background: #5cae48;
    color: #fff;
}

.ms-sl-btn--green:hover:not(:disabled) {
    background: #4f9a3e;
    color: #fff;
}

.ms-sl-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.ms-sl-filters {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    padding: 12px 14px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.ms-sl-search {
    flex: 1 1 220px;
    min-width: 200px;
}

.ms-sl-select {
    flex: 0 1 180px;
    min-width: 150px;
}

.ms-sl-select .form-select {
    width: 100%;
}

.ms-sl-select--placeholder {
    opacity: 0.7;
}

.ms-sl-hint {
    font-size: 11px;
    color: #9ca3af;
    width: 100%;
    margin: -4px 0 0;
}

.ms-sl-table-wrap {
    overflow-x: auto;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.ms-sl-table {
    width: 100%;
    margin: 0;
    border-collapse: collapse;
}

.ms-sl-table th {
    padding: 10px 12px;
    background: #f8fafc;
    border-bottom: 1px solid #e5e7eb;
    color: #6b7280;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    text-align: left;
}

.ms-sl-table td {
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    font-size: 13px;
    vertical-align: middle;
}

.ms-sl-table tbody tr:last-child td {
    border-bottom: 0;
}

.ms-sl-pair {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 220px;
}

.ms-sl-avatars {
    display: flex;
    flex-shrink: 0;
}

.ms-sl-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid #fff;
    font-size: 10px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.02em;
}

.ms-sl-avatar + .ms-sl-avatar {
    margin-left: -8px;
}

.ms-sl-avatar--mentor {
    background: #0b3454;
}

.ms-sl-avatar--mentee {
    background: #5cae48;
}

.ms-sl-pair-names {
    font-weight: 700;
    color: #111827;
    line-height: 1.25;
}

.ms-sl-pair-campus {
    font-size: 12px;
    font-weight: 400;
    color: #6b7280;
}

.ms-sl-chip {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.4;
    white-space: nowrap;
}

.ms-sl-chip--type {
    background: #eff6ff;
    color: #1d4ed8;
}

.ms-sl-chip--role {
    background: #f3f4f6;
    color: #374151;
}

.ms-sl-chip--source {
    background: #ecfdf5;
    color: #047857;
}

.ms-sl-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    color: #1d4ed8;
    background: #fff;
}

.ms-sl-link:hover {
    background: #eff6ff;
    color: #1e3a8a;
}

.ms-sl-action {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-height: 30px;
    padding: 4px 10px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background: #fff;
    color: #6b7280;
    font-size: 12px;
    font-weight: 600;
}

.ms-sl-action:disabled {
    cursor: not-allowed;
    opacity: 0.55;
}

.ms-sl-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.ms-sl-empty {
    padding: 28px 16px;
    text-align: center;
    color: #6b7280;
    font-size: 14px;
}

.ms-sl-pager {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/features/management/mentorship/MentorshipSessionLog.css"],"names":[],"mappings":"AAAA,4EAA4E;;AAE5E;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB","sourcesContent":["/* P11-BATCH-004 — scoped Session Log tab. Do not import prototype chrome. */\n\n.ms-sl {\n    color: #1f2937;\n}\n\n.ms-sl-header {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 16px;\n}\n\n.ms-sl-title {\n    margin: 0 0 4px;\n    font-size: 22px;\n    font-weight: 700;\n    color: #111827;\n}\n\n.ms-sl-sub {\n    margin: 0;\n    font-size: 13px;\n    color: #6b7280;\n}\n\n.ms-sl-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    min-height: 36px;\n    padding: 6px 16px;\n    border-radius: 999px;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.ms-sl-btn--green {\n    border: 1px solid #5cae48;\n    background: #5cae48;\n    color: #fff;\n}\n\n.ms-sl-btn--green:hover:not(:disabled) {\n    background: #4f9a3e;\n    color: #fff;\n}\n\n.ms-sl-btn:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n.ms-sl-filters {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 16px;\n    padding: 12px 14px;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.ms-sl-search {\n    flex: 1 1 220px;\n    min-width: 200px;\n}\n\n.ms-sl-select {\n    flex: 0 1 180px;\n    min-width: 150px;\n}\n\n.ms-sl-select .form-select {\n    width: 100%;\n}\n\n.ms-sl-select--placeholder {\n    opacity: 0.7;\n}\n\n.ms-sl-hint {\n    font-size: 11px;\n    color: #9ca3af;\n    width: 100%;\n    margin: -4px 0 0;\n}\n\n.ms-sl-table-wrap {\n    overflow-x: auto;\n    background: #fff;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.ms-sl-table {\n    width: 100%;\n    margin: 0;\n    border-collapse: collapse;\n}\n\n.ms-sl-table th {\n    padding: 10px 12px;\n    background: #f8fafc;\n    border-bottom: 1px solid #e5e7eb;\n    color: #6b7280;\n    font-size: 12px;\n    font-weight: 600;\n    white-space: nowrap;\n    text-align: left;\n}\n\n.ms-sl-table td {\n    padding: 12px;\n    border-bottom: 1px solid #f3f4f6;\n    font-size: 13px;\n    vertical-align: middle;\n}\n\n.ms-sl-table tbody tr:last-child td {\n    border-bottom: 0;\n}\n\n.ms-sl-pair {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 220px;\n}\n\n.ms-sl-avatars {\n    display: flex;\n    flex-shrink: 0;\n}\n\n.ms-sl-avatar {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    border: 2px solid #fff;\n    font-size: 10px;\n    font-weight: 700;\n    color: #fff;\n    letter-spacing: 0.02em;\n}\n\n.ms-sl-avatar + .ms-sl-avatar {\n    margin-left: -8px;\n}\n\n.ms-sl-avatar--mentor {\n    background: #0b3454;\n}\n\n.ms-sl-avatar--mentee {\n    background: #5cae48;\n}\n\n.ms-sl-pair-names {\n    font-weight: 700;\n    color: #111827;\n    line-height: 1.25;\n}\n\n.ms-sl-pair-campus {\n    font-size: 12px;\n    font-weight: 400;\n    color: #6b7280;\n}\n\n.ms-sl-chip {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1.4;\n    white-space: nowrap;\n}\n\n.ms-sl-chip--type {\n    background: #eff6ff;\n    color: #1d4ed8;\n}\n\n.ms-sl-chip--role {\n    background: #f3f4f6;\n    color: #374151;\n}\n\n.ms-sl-chip--source {\n    background: #ecfdf5;\n    color: #047857;\n}\n\n.ms-sl-link {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    color: #1d4ed8;\n    background: #fff;\n}\n\n.ms-sl-link:hover {\n    background: #eff6ff;\n    color: #1e3a8a;\n}\n\n.ms-sl-action {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    min-height: 30px;\n    padding: 4px 10px;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    background: #fff;\n    color: #6b7280;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.ms-sl-action:disabled {\n    cursor: not-allowed;\n    opacity: 0.55;\n}\n\n.ms-sl-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.ms-sl-empty {\n    padding: 28px 16px;\n    text-align: center;\n    color: #6b7280;\n    font-size: 14px;\n}\n\n.ms-sl-pager {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
